<footer class="footer bgx4">
    <div class="container-fluid bgxx"></div>

    <div class="container-fluid bgx3">
      <div class="row" style="margin-top: 25px;">
        <div class="col-sm-3">
          <img class="img-fluid" src="assets/img/Logonew.png" />
        </div>
        <div class="col-sm-3 footer-padding">
          <p><b>Informasi</b></p>
          <p class="nav-item nav-item-style">
            <a class="nav-link" href="https://sukandadjaya.com/" style="color: #737B7D; margin-left: -15px;">
              Tentang Sukanda Djaya
            </a>
          </p>
          <p class="nav-item nav-item-style">
            <a class="nav-link" [routerLink]="['/syarat&ketentuan']" style="color: #737B7D; margin-left: -15px;">
              Syarat & Ketentuan
            </a>
          </p>
          <p class="nav-item nav-item-style">
            <a class="nav-link" [routerLink]="['/kebijakan-privasi']" style="color: #737B7D; margin-left: -15px;">
              Kebijakan Privasi
            </a>
          </p>
          <p class="nav-item nav-item-style">
            <a class="nav-link" [routerLink]="['/register-training']" style="color: #737B7D; margin-left: -15px;">
              Daftar Training
            </a>
          </p>
          <p class="nav-item nav-item-style">
            <a class="nav-link" [routerLink]="['/hubungi-kami']" style="color: #737B7D; margin-left: -15px;">
              Hubungi Kami
            </a>
          </p>
        </div>
        <div class="col-sm-3 footer-padding">
          <p><b>Akses Cepat</b></p>
          <p class="nav-item nav-item-style">
            <a class="nav-link"
              href="https://buyer.sukandaonelink.com/login"
              style="color: #737B7D; margin-left: -15px;">
              Login
            </a>
          </p>
          <p class="nav-item nav-item-style" >
            <a
              class="nav-link"
              href="https://buyer.sukandaonelink.com/aktivasi"
              style="color: #737B7D; margin-left: -15px;"
            >
              Aktifasi
            </a>
          </p>
          <p class="nav-item nav-item-style">
            <!-- <a
              class="nav-link"
              [routerLink]="['/bantuan']"
              style="color: #737B7D; margin-left: -15px;"
            >
              Panduan dan Bantuan
            </a> -->
          </p>
        </div>
        <div class="col-sm-3 footer-padding">
          <p style="font-size: 18px;line-height: 24px; margin-right: 147px;
          letter-spacing: 0.1px;"><b>Ikuti Kami</b></p>
          <div>
            <a href="https://id-id.facebook.com/sukandadjayaofficial/">
              <img class="icon" src="assets/img/Facebook.png" />
            </a>
            <a href="https://www.instagram.com/sukandadjaya/?hl=id">
              <img class="icon" src="assets/img/igicon.png" />
            </a>
            <a href="https://youtube.com/channel/UChzO8UAYyIRgH0tUg6JQ-Ew">
              <img class="icon" src="assets/img/yt.png" />
            </a>
            <a href="https://twitter.com/ptsukandadjaya">
              <img class="icon" src="assets/img/twitter.png" />
            </a>
            <a href="https://id.linkedin.com/company/diamond-cold-storage">
              <img class="icon" src="assets/img/linkedIn.png" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="container-fluid bgx3">
      <div class="row">
        <div class="col-sm-2">
          <p><b>Our Product</b></p>
        </div>
        <div class="col-sm-2">
          <img class="logo-img-2" src="assets/img/bel.png" />
        </div>
        <div class="col-sm-2">
          <img class="logo-img-2" src="assets/img/goldefarm.png" />
        </div>
        <div class="col-sm-2">
          <img class="logo-img-2" src="assets/img/Ovaltine.png" />
        </div>
        <div class="col-sm-2">
          <img class="logo-img-2" src="assets/img/Leekumkee.png" />
        </div>
        <div class="col-sm-2">
          <img class="logo-img-2" src="assets/img/herchey.png" />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-2"></div>
        <div class="col-sm-2">
          <img class="logo-img-2" src="assets/img/ellevire.png" />
        </div>
        <div class="col-sm-2">
          <img class="logo-img-2" src="assets/img/bon-patis.png" />
        </div>
        <div class="col-sm-2">
          <img class="logo-img-2" src="assets/img/diamond-milk.png" />
        </div>
        <div class="col-sm-2">
          <img class="logo-img-2" src="assets/img/FILIPO-BERIO-500x500.png" />
        </div>
        <div class="col-sm-2">
          <img class="logo-img-2" src="assets/img/Kinder-Bueno-500x500.png" />
        </div>
      </div>
    </div> -->
  </footer>
